import { api, unwrap } from "./httpClient";
import type { Permission, Role } from "../types/api";

export interface CreateRolePayload {
  name: string;
  label: string;
  description?: string;
  permissions: string[];
}

export interface UpdateRolePayload {
  label?: string;
  description?: string;
}

export interface AssignRolePayload {
  userId: number;
  roleId: number;
}

export const listRoles = () =>
  unwrap<Role[]>(api({ method: "GET", url: "/admin/roles" }));

export const listPermissions = () =>
  unwrap<Permission[]>(api({ method: "GET", url: "/admin/permissions" }));

export const createRole = (payload: CreateRolePayload) =>
  unwrap<Role>(api({ method: "POST", url: "/admin/roles", data: payload }));

export const updateRole = (roleId: number, payload: UpdateRolePayload) =>
  unwrap<Role>(
    api({ method: "PATCH", url: `/admin/roles/${roleId}`, data: payload })
  );

export const updateRolePermissions = (roleId: number, permissions: string[]) =>
  unwrap<Role>(
    api({
      method: "PATCH",
      url: `/admin/roles/${roleId}/permissions`,
      data: { permissions },
    })
  );

export const assignRole = (payload: AssignRolePayload) =>
  unwrap<Role>(
    api({ method: "PATCH", url: "/admin/roles/assign", data: payload })
  );
